export const DATA_TEST_ID_PREFIX = "NCX_Livechat";

export const DATA_TEST_ID_PREFIX_CONNECT_TO_NEXTIVA = "NCX::ConnectwithNextiva";


export const LIVECHAT_CLICK_EVENTS = {
  COMMON_HEADER_START_NEW_COVERSATION: "Started a new conversation from header",
  COMMON_HEADER_CHAT_HISTORY: "Opened chat history from header",
  COMMON_HEADER_DOWNLOAD_TRANSCRIPT: "Downloaded transcript from header",
  COMMON_HEADER_MUTE_NOTIFICATION: "Muted notifications via header",
  COMMON_HEADER_UNMUTE_NOTIFICATION: "Unmuted notifications via header",
  COMMON_HEADER_MINIMIZE: "Minimized chat from header",
  COMMON_HEADER_END_CHAT: "Ended chat from header",
  COMMON_HEADER_TOGGLE_SIZE: "Toggled chat window size from header",
  INPUT_BOX_HOME_BUTTON_CLICK:
    "Clicked home button inside conversation input box",
  CLOSE_CONVERSATION_DIALOG_DOWNLOAD_TRANSCRIPT:
    "Downloaded transcript from close chat dialog",
  CLOSE_CONVERSATION_DIALOG_CONTINUE_CHAT:
    "Chose to continue chat from close chat dialog",
  CLOSE_CONVERSATION_DIALOG_GO_BACK:
    "Went back to landing page from close chat dialog",
  INITIAL_OFFLINE_FORM_SUBMIT:
    "Submitted offline form (outside business hours)",
  LANDING_RESUME_CONVERSATION:
    "Resumed previous conversation from landing page",
  LANDING_DOWNLOAD_HISTORY: "Downloaded conversation history from landing page",
  SHOW_EXISTING_CONVERSATION_HISTORY:
    "Viewed existing conversation from landing page",
  START_UP_WIDGET: "Opened or maximized chat widget",
  CONTINUE_TERMS_CONDITIONS: "Accepted terms and conditions in conversation",
  PRIVACY_POLICY_ACCEPT: "Accepted privacy policy in conversation",
  PRIVACY_POLICY_CLICKED: "Clicked on privacy policy in conversation",
};

  export const LIVECHAT_LOG_EVENTS = {
    CLOSE_CHAT: "ncx::LiveChat::CloseChat",
    START_CHAT: "ncx::LiveChat::StartChat",
    SUBMIT_ONLINE_FORM: "ncx::LiveChat::SubmitOnlineForm",
    CONNECT_NEXTIVA_AGENT_CHAT: "NCX::ConnectwithNextiva::AgentChat",
    CONNECT_NEXTIVA_BOT_CHAT: "NCX::ConnectwithNextiva::BotChat",
  };

  export const LIVECHAT_LOG_ACTIONS = {
    CLOSE_CHAT_WITHOUT_AGENT: "Chat ended during bot flow (no agent involved)",
    CLOSE_CHAT_WITH_AGENT: "Chat ended during live agent conversation",
    START_CHAT: "Started a new chat",
    SUBMIT_ONLINE_FORM: "Submitted pre-chat form",
  }

  export const LIVECHAT_LOG_KEYS = {
    action: "action",
    isSandbox: "isSandbox",
    isConnectToNextiva: "isConnectToNextiva",
    isTermsAcceptedForSession: "isTermsAcceptedForSession",
    widgetConfigId: "widgetconfigId",
    campaignId: "campaignId",
    timeStamp: "timestamp",
    sessionId: "sessionId",
    isBotEnabled: "isBotEnabled",
    isAIBot: "isAIBot",
    hasImageAttached: "hasImageAttached",
    FAQArticleClicked: "FAQArticleClicked",
    isAnonymous: "isAnonymous",
    fromRequestValue: "fromRequestValue",
    otherDetails: "details"
}